import { replace } from 'react-router-redux';

import apiCheckRegistrationStatus from '../../utils/checkRegistration/apiCheckRegistrationStatus';

// IMPORT ACTIONS
import {
    EMAIL_COLLECTED,
    SHOW_NEXT_ACTION_ANIMATION,
    IS_NEXT_ACTION_TRANSITION,
    onFinishMultiAction
} from '../Widget/actions';

// DEFINE CONSTS FOR ACTION TYPES
export const CHECK_REGISTRATION_INITIATED = 'CHECK_REGISTRATION_INITIATED';
export const CHECK_REGISTRATION_CANCELLED = 'CHECK_REGISTRATION_CANCELLED';
export const CHECK_REGISTRATION_SUBMITTING = 'CHECK_REGISTRATION_SUBMITTING';
export const CHECK_REGISTRATION_ERROR = 'CHECK_REGISTRATION_ERROR';
export const CHECK_REGISTRATION_COMPLETED = 'CHECK_REGISTRATION_COMPLETED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

let timeout = null;

export const onGoToForm = (actionIdentifier, actionInitiated) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: CHECK_REGISTRATION_INITIATED,
            payload: actionIdentifier
        });
    }

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch(replace('/checkRegistration/details'));
};

export const onGoToStartScreen = actionIdentifier => dispatch => {
    dispatch({
        type: CHECK_REGISTRATION_CANCELLED,
        payload: actionIdentifier
    });

    dispatch(replace('/checkRegistration'));
};

export const submitCheckRegistrationForm = (
    apiRequestData,
    values,
    isMultiActionsCard,
    actionIdentifier,
    actionCompletedTime,
    skipEndCard
) => dispatch => {
    dispatch({
        type: CHECK_REGISTRATION_SUBMITTING,
        payload: { isFormSubmitting: true }
    });

    apiCheckRegistrationStatus(apiRequestData, values, actionCompletedTime)
        .then(data => {
            dispatch({
                type: CHECK_REGISTRATION_COMPLETED,
                payload: {
                    ...data,
                    actionIdentifier
                }
            });

            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else if (!skipEndCard) {
                dispatch(replace('/checkRegistration/success'));
            }

            dispatch({
                type: CHECK_REGISTRATION_SUBMITTING,
                payload: { isFormSubmitting: false }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: { actionIdentifier }
            });

            dispatch({
                type: CHECK_REGISTRATION_ERROR,
                payload: null
            });

            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }
        })
        .catch(err => {
            let errorMessage;
            if (err.message) {
                errorMessage =
                    'An error has occured. ' +
                    (err.modelState !== undefined
                        ? Object.values(err.modelState)[0].toString()
                        : 'Please try again later!');
            } else {
                errorMessage =
                    'There was an error while submitting your form! Please try again later!';
            }

            dispatch({
                type: CHECK_REGISTRATION_ERROR,
                payload: errorMessage
            });

            if (timeout !== null) {
                clearTimeout(timeout);
                timeout = null;
            }

            timeout = setTimeout(() => {
                timeout = null;
                dispatch({
                    type: CHECK_REGISTRATION_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: CHECK_REGISTRATION_SUBMITTING,
                payload: { isFormSubmitting: false }
            });
        });
};
